import { styled } from "styled-components";

export const CTAWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 24px;
  z-index: 2;
  position: relative;
  overflow: hidden;

  ${({ theme }) => theme.breakpoints.md.query} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const CTAContainer = styled.div`
  background: ${({ theme }) => theme.colors.default[900]};
  width: 100%;
  display: flex;
  padding: 36px 52px 36px 36px;
  align-items: center;
  align-content: center;
  justify-content: space-between;
  gap: 48px;
  border-radius: 24px;
  max-width: 1024px;
  margin: 0 auto;
  z-index: 2;

  ${({ theme }) => theme.breakpoints.sm.query} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const CTATextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: flex-start;
`;

export const CTAHeadline = styled.h3`
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%; /* 32px */
  letter-spacing: 0.96px;
  color: ${({ theme }) => theme.colors.base};
`;

export const CTAText = styled.p`
  color: ${({ theme }) => theme.colors.default[50]};
  font-size: 17px;
  font-style: normal;
  line-height: 150%; /* 25.5px */
`;

export const Arch = styled.div`
  color: ${({ theme }) => theme.colors.default[50]};
  display: block;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  margin-bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 0;

  @media (min-width: 2400px) {
    display: none;
  }
`;
